import * as React from 'react';
import { BuildIcon } from '../../../components/Icons/BuildIcon';
import { DecksIcon } from '../../../components/Icons/DecksIcon';
import { PeopleIcon } from '../../../components/Icons/PeopleIcon';
import { ShipIcon } from '../../../components/Icons/ShipIcon';
import { SpeechIcon } from '../../../components/Icons/SpeechIcon';
import { __ } from '../../../helpers/TranslationService';

export interface IShipOverview {
    title: string;
    description: string;
    images: string[];
    length: number;
    manufactureYear: number;
    passengers: number;
    decks: number;
    usersReview?: any;
    boardLanguages: string;
    highlights: string[];
    category: number;
    portalId: string;
}

interface IShipFact {
    iconComp: React.FC<any>;
    title: string;
    text: string;
}

const ShipFact = (props: IShipFact) => (
    <li>
        <props.iconComp className="icon" width={22} height={22} />
        <div className="factText">
            <div className="factName">{props.title}</div>
            <div className="factValue">{props.text}</div>
        </div>
    </li>
);

export const ShipFacts = (props: IShipOverview) => {
    const { length, passengers, decks, manufactureYear, boardLanguages } = props;
    const lengthMetric = props.portalId === 'dreamlines.com' ? 'ft' : 'm';
    return (
        <div className="shipFacts">
            <ul>
                {Boolean(length) && (
                    <ShipFact
                        iconComp={ShipIcon}
                        title={__('ship length', 'dreamlines')}
                        text={`${length} ${lengthMetric}`}
                    />
                )}
                {Boolean(passengers) && (
                    <ShipFact
                        iconComp={PeopleIcon}
                        title={__('passengers', 'dreamlines')}
                        text={passengers.toString()}
                    />
                )}
                {Boolean(decks) && (
                    <ShipFact
                        iconComp={DecksIcon}
                        title={__('ship numDecks', 'dreamlines')}
                        text={decks.toString()}
                    />
                )}
                {Boolean(manufactureYear) && (
                    <ShipFact
                        iconComp={BuildIcon}
                        title={__('ship construction year', 'dreamlines')}
                        text={manufactureYear.toString()}
                    />
                )}
                {Boolean(boardLanguages) && (
                    <ShipFact
                        iconComp={SpeechIcon}
                        title={__('language on board', 'dreamlines')}
                        text={boardLanguages}
                    />
                )}
            </ul>
        </div>
    );
};
